import gql from 'graphql-tag';

export default gql`
  query cartGetOrderDeadline($supplierId: Int!, $storeId: String!) {
    cartGetOrderDeadline(supplierId: $supplierId, storeId: $storeId)
  }
`;
